import { render, staticRenderFns } from "./ExtraDetailInfoList.vue?vue&type=template&id=94fd5c14&"
import script from "./ExtraDetailInfoList.vue?vue&type=script&lang=js&"
export * from "./ExtraDetailInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports